    import { useNavigate } from "react-router-dom";
    import React from "react";
   
    const handleUserNavigation = (navigate, userUrl, adminUrl) => {
        const storedData = localStorage.getItem("userDetails");
        if (!storedData) return;

        try {
            const parsedData = JSON.parse(storedData);
            const roleName = parsedData?.[0]?.roleName;
            if (!roleName) {
                console.error("Role name not found in userDetails");
                // Fallback or error handling route
                navigate("/error");
                return;
            }
            if (roleName !== "ADMIN" && roleName !== "TOOLADMIN") {
                navigate(userUrl);
            } else {
                navigate(adminUrl);
            }
        } catch (error) {
            console.error("Error parsing userRoles from localStorage", error);
            // Fallback or error handling route
            navigate("/error");
        }
    };
 export default handleUserNavigation;